export default "__VITE_ASSET__90f52e73__"